export default "__VITE_ASSET__3361a302__"